import { global } from '../constants';

export const data = {
  banner: {
    background: global.banner + 'fine-arts.webp',
    title: 'Fine Arts',
    crumb: 'Industries / Fine Arts',
  },

  whychoosus: {
    firstImage: global.banner + 'firstArtt.jpg',
    secondImage: global.banner + 'secondArt.jpg',
    img: global.banner + 'metals-2.jpg',
    title: 'Trusted Fine Art Logistics & Handling Experts',
    subtitle:
      'Precision, discretion, and white-glove service—crafted for galleries, museums, collectors, and institutions.',
    description: {
      short:
        'From private collections to global exhibitions—our fine art logistics protect every masterpiece.',
      long: "We understand that art is more than an object—it's a legacy, a cultural treasure, and a valuable investment. Our fine art logistics services are built around careful planning, temperature-controlled environments, expert handlers, and secure transport solutions. Whether you're moving a single masterpiece or a full exhibition, we ensure every detail is managed with museum-grade care and professionalism.",
    },
  },

  whatwedo: {
    main: global.banner + 'fine-pack.jpg',
    title: 'What We Do!',
    subtitle: 'Specialized Solutions for Fine Art Transportation',
    description:
      'Our fine arts logistics solutions are trusted by curators, collectors, and cultural institutions for the movement, storage, and installation of artworks. Every step is executed with meticulous attention and tailored to each artwork’s unique requirements.',
    works: [
      {
        icon: global.icons2 + 'pic3.png',
        serial: '01',
        title: 'Art Transport & Handling',
        description:
          'Climate-controlled, shock-absorbing transport with experienced art handlers. Custom crating and white-glove care for both domestic and international moves.',
      },
      {
        icon: global.icons2 + 'warehouse.png',
        serial: '02',
        title: 'Art Storage & Climate-Controlled Vaults',
        description:
          'Short- and long-term storage in humidity- and temperature-controlled environments. 24/7 surveillance and private viewings on request.',
      },
      {
        icon: global.icons2 + 'support.png',
        serial: '03',
        title: 'Insurance & Valuation Coordination',
        description:
          'Collaboration with certified appraisers and insurers to provide valuation reports, condition updates, and coverage for stored or transported works.',
      },
    ],
  },

  blogs: {
    title: 'OUR STANDARDS',
    subtitle: 'Proactive Protection at Every Level',
    description:
      'Our services are built around rigorous risk assessments and preventive measures — safeguarding your assets against even the smallest vulnerabilities.',
    blogs: [
      {
        image: global.banner + 'security.webp',
        icon: '🛡️',
        title: 'Multi-Layered Security Protocols',
        description:
          'From secure facilities to vetted handlers, our entire system is built for control and vigilance — ensuring assets are protected from pickup to delivery.',
      },
      {
        image: global.banner + 'planning.png',
        icon: '⚠️',
        title: 'Contingency Planning & Redundancy',
        description:
          'We prepare for every possibility. With redundant tracking, alternate routing, and backup personnel, your shipment remains secure — even in the unexpected.',
      },
    ],
  },
};
